import React from "react";

const CaptureSchemeAllocation = () => {
    return <div>CaptureSchemeAllocation</div>;
};

export default CaptureSchemeAllocation;